import axios from 'axios/index'

import config from '../../../config'
import action, { actionFailed } from '../../../util/action'
import createAsyncConst from '../../../util/createAsyncConst'

export const UPDATE_ATTENDANCE_LAUNDRY = createAsyncConst(
  'UPDATE_ATTENDANCE_LAUNDRY'
)

export const FETCH_ATTENDANCE_PARTNERS = createAsyncConst(
  'FETCH_ATTENDANCE_PARTNERS'
)
export const EDIT_ATTENDANCE_LAUNDRY = createAsyncConst(
  'EDIT_ATTENDANCE_LAUNDRY'
)

export const EDIT_SERVICE_ITEM = createAsyncConst('EDIT_SERVICE_ITEM')
export const EDIT_CLIENT_ADDRESS = createAsyncConst('EDIT_CLIENT_ADDRESS')
export const FETCH_LAUNDRY_SERVICE_TYPES = createAsyncConst(
  'FETCH_LAUNDRY_SERVICE_TYPES'
)

export const DELETE_ITEM = createAsyncConst('DELETE_ITEM')
export const FETCH_OSS_REPORT = createAsyncConst('FETCH_OSS_REPORT')
export const CLOSE_LAUNDRY_OS = createAsyncConst('CLOSE_LAUNDRY_OS')
export const REOPEN_LAUNDRY_OS = createAsyncConst('REOPEN_LAUNDRY_OS')

export const CLOSE_ALL_LAUNDRY_OS = createAsyncConst('CLOSE_ALL_LAUNDRY_OS')
// export const TOOGLE_URGENT = createAsyncConst('TOOGLE_URGENT')
// export const TOOGLE_SHOW_IMAGES = createAsyncConst('TOOGLE_SHOW_IMAGES')
// export const TOOGLE_PERSONALIZED = createAsyncConst('TOOGLE_PERSONALIZED')
// export const TOOGLE_REWORK = createAsyncConst('TOOGLE_REWORK')
// export const FETCH_DOCUMENTS = createAsyncConst('FETCH_DOCUMENTS')
// export const DOWNLOAD_BOLETO = createAsyncConst('DOWNLOAD_BOLETO')
// export const SEND_MAIL_BILLING = createAsyncConst('SEND_MAIL_BILLING')
// export const TOOGLE_DELIVERY = createAsyncConst('TOOGLE_DELIVERY')

export function fetchAttendancePartner(filters = {}, rows, page) {
  return dispatch => {
    dispatch(action(FETCH_ATTENDANCE_PARTNERS.ACTION))
    return axios
      .get(`${config.API_URL}/laundryService`, {
        params: {
          filters: JSON.stringify(filters),
          rows: rows || 10,
          page: page || 1,
        },
      })
      .then(resp => {
        dispatch(
          action(FETCH_ATTENDANCE_PARTNERS.SUCCESS, {
            data: resp.data,
            filters,
          })
        )
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_ATTENDANCE_PARTNERS, e)))
  }
}

export function edit(id, filters = {}) {
  return dispatch => {
    dispatch(action(EDIT_ATTENDANCE_LAUNDRY.ACTION, { id }))
    return axios
      .get(`${config.API_URL}/laundryService/${id}`, {
        params: filters,
      })
      .then(resp => resp.data)
      .then(data => {
        dispatch(
          action(EDIT_ATTENDANCE_LAUNDRY.SUCCESS, {
            data: data,
            filters,
          })
        )
        return data
      })
      .catch(e => dispatch(actionFailed(EDIT_ATTENDANCE_LAUNDRY, e)))
  }
}

export function serviceItemAddress(id) {
  return dispatch => {
    dispatch(action(EDIT_CLIENT_ADDRESS.ACTION, { id }))
    return axios
      .get(`${config.API_URL}/laundry-service-item/address/${id}`)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(EDIT_CLIENT_ADDRESS.SUCCESS, data))
        return data
      })
      .catch(e => dispatch(actionFailed(EDIT_CLIENT_ADDRESS, e)))
  }
}

export function updateServiceItem(id, data) {
  return dispatch => {
    dispatch(action(UPDATE_ATTENDANCE_LAUNDRY.ACTION, { id }))
    return axios
      .put(`${config.API_URL}/laundry-service-item/${id}`, data)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(UPDATE_ATTENDANCE_LAUNDRY.SUCCESS, data))
        return data
      })
      .catch(e => {
        dispatch(actionFailed(UPDATE_ATTENDANCE_LAUNDRY, e))
        return e
      })
  }
}

export function updateRework(id, data) {
  return dispatch => {
    dispatch(action(UPDATE_ATTENDANCE_LAUNDRY.ACTION, { id }))
    return axios
      .put(`${config.API_URL}/laundry-service-item/set-rework/${id}`, data)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(UPDATE_ATTENDANCE_LAUNDRY.SUCCESS, data))
        return data
      })
      .catch(e => dispatch(actionFailed(UPDATE_ATTENDANCE_LAUNDRY, e)))
  }
}

export function updateDelivery(id, data) {
  return dispatch => {
    dispatch(action(UPDATE_ATTENDANCE_LAUNDRY.ACTION, { id }))
    return axios
      .put(`${config.API_URL}/laundry-service-item/set-delivery/${id}`, data)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(UPDATE_ATTENDANCE_LAUNDRY.SUCCESS, data))
        return data
      })
      .catch(e => dispatch(actionFailed(UPDATE_ATTENDANCE_LAUNDRY, e)))
  }
}

export function updatePersonalized(id, data) {
  return dispatch => {
    dispatch(action(UPDATE_ATTENDANCE_LAUNDRY.ACTION, { id }))
    return axios
      .put(
        `${config.API_URL}/laundry-service-item/set-personalized/${id}`,
        data
      )
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(UPDATE_ATTENDANCE_LAUNDRY.SUCCESS, data))
        return data
      })
      .catch(e => dispatch(actionFailed(UPDATE_ATTENDANCE_LAUNDRY, e)))
  }
}

export function deleteItem(id) {
  return dispatch => {
    dispatch(action(DELETE_ITEM.ACTION))
    return axios
      .delete(`${config.API_URL}/laundry-service-item/${id}`)
      .then(data => {
        dispatch(action(DELETE_ITEM.SUCCESS, data))
        return data
      })
      .catch(e => dispatch(actionFailed(DELETE_ITEM, e)))
  }
}

export function editServiceItem(id) {
  return dispatch => {
    dispatch(action(EDIT_SERVICE_ITEM.ACTION, { id }))
    return axios
      .get(`${config.API_URL}/laundry-service-item/${id}`)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(EDIT_SERVICE_ITEM.SUCCESS, data))
        return data
      })
      .catch(e => dispatch(actionFailed(EDIT_SERVICE_ITEM, e)))
  }
}

export function fetchServiceTypesForLaundry(laundryId) {
  return dispatch => {
    dispatch(action(FETCH_LAUNDRY_SERVICE_TYPES.ACTION))
    return axios
      .get(`${config.API_URL}/service-types-for-laundry/${laundryId}`)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(FETCH_LAUNDRY_SERVICE_TYPES.SUCCESS, data))
        return data?.data || []
      })
      .catch(e => dispatch(actionFailed(FETCH_LAUNDRY_SERVICE_TYPES, e)))
  }
}

export function exportOSsRelatory(filter, url) {
  return dispatch => {
    dispatch(action(FETCH_OSS_REPORT.ACTION))
    return axios({
      url: `${config.API_URL}/${url}`,
      method: 'POST',
      responseType: 'blob',
      headers: { Accept: 'application/vnd.ms-excel' },
      data: filter,
    })
      .then(response => {
        dispatch(action(FETCH_OSS_REPORT.SUCCESS, {}))
        const blob = new Blob([response.data], { type: response.data.type })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'unknown'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1].replaceAll('"', '')
          }
        }
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
      .catch(e => {
        dispatch(actionFailed(FETCH_OSS_REPORT, e))
      })
  }
}

export function closeLaundryOS(id) {
  return dispatch => {
    dispatch(action(CLOSE_LAUNDRY_OS.ACTION, { id }))
    return axios
      .post(`${config.API_URL}/laundry-service/close/${id}`)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(CLOSE_LAUNDRY_OS.SUCCESS, data))
        return data
      })
      .catch(e => dispatch(actionFailed(CLOSE_LAUNDRY_OS, e)))
  }
}

export function reopenOS(id) {
  return dispatch => {
    dispatch(action(REOPEN_LAUNDRY_OS.ACTION))
    return axios
      .get(`${config.API_URL}/laundry-service/reopen/${id}`)
      .then(resp => {
        dispatch(action(REOPEN_LAUNDRY_OS.SUCCESS, { id, data: resp.data }))
        return resp
      })
      .catch(e => dispatch(actionFailed(REOPEN_LAUNDRY_OS, e)))
  }
}

export function closeAllLaundryOSs() {
  return dispatch => {
    dispatch(action(CLOSE_ALL_LAUNDRY_OS.ACTION))
    return axios
      .post(`${config.API_URL}/laundry-service/closeAll`)
      .then(data => {
        dispatch(action(CLOSE_ALL_LAUNDRY_OS.SUCCESS, data))
        return data
      })
      .catch(e => dispatch(actionFailed(CLOSE_ALL_LAUNDRY_OS, e)))
  }
}

// export function clearFilters() {
//   return {
//     type: 'ATTENDANCE_LAUNDRY_CLEAR_FILTERS',
//   }
// }

// export function toogleIsPersonalized(id) {
//   return dispatch => {
//     dispatch(action(TOOGLE_PERSONALIZED.ACTION))
//     return axios
//       .post(`${config.API_URL}/laundryServiceItem/toogle-personalized/${id}`)
//       .then(data => {
//         dispatch(action(TOOGLE_PERSONALIZED.SUCCESS, { id }))
//         return data
//       })
//       .catch(e => dispatch(actionFailed(TOOGLE_PERSONALIZED, e)))
//   }
// }

// export function fetchDocuments(id) {
//   return dispatch => {
//     dispatch(action(FETCH_DOCUMENTS.ACTION))
//     return axios
//       .get(`${config.API_URL}/laundryService/documents/${id}`)
//       .then(data => {
//         dispatch(action(FETCH_DOCUMENTS.SUCCESS, { id }))
//         return data
//       })
//       .catch(e => dispatch(actionFailed(FETCH_DOCUMENTS, e)))
//   }
// }

// export function updateServiceBill(id, values) {
//   return dispatch => {
//     dispatch(action(FETCH_DOCUMENTS.ACTION))

//     const formData = new FormData()

//     values.files.length &&
//       Object.values(values.files).map(key => {
//         formData.append(`files[]`, key)
//       })

//     return axios
//       .post(`${config.API_URL}/laundryService/documents/${id}`, formData)
//       .then(resp => {
//         dispatch(action(FETCH_DOCUMENTS.SUCCESS, { id, data: resp.data }))
//         return resp
//       })
//       .catch(e => dispatch(actionFailed(FETCH_DOCUMENTS, e)))
//   }
// }

// export function download(id) {
//   return dispatch => {
//     dispatch(action(DOWNLOAD_BOLETO.ACTION))
//     return axios({
//       url: `${config.API_URL}/laundryService/documents/${id}/download`,
//       method: 'get',
//       responseType: 'blob',
//       headers: { Accept: 'application/zip' },
//     })
//       .then(resp => {
//         dispatch(action(DOWNLOAD_BOLETO.SUCCESS, { id }))
//         const url = window.URL.createObjectURL(new Blob([resp.data]))
//         const link = document.createElement('a')

//         link.href = url
//         link.setAttribute('download', `boletos_os_${id}.zip`)
//         document.body.appendChild(link)
//         link.click()
//         return resp
//       })
//       .catch(e => dispatch(actionFailed(DOWNLOAD_BOLETO, e)))
//   }
// }

// export function sendMail(id) {
//   return dispatch => {
//     dispatch(action(SEND_MAIL_BILLING.ACTION))
//     return axios
//       .get(`${config.API_URL}/laundryService/${id}/send-mail-billing`)
//       .then(resp => {
//         dispatch(action(SEND_MAIL_BILLING.SUCCESS, { id, data: resp.data }))
//         return resp
//       })
//       .catch(e => dispatch(actionFailed(SEND_MAIL_BILLING, e)))
//   }
// }

// export function toogleIsDelivery(id, values = {}) {
//   return dispatch => {
//     dispatch(action(TOOGLE_DELIVERY.ACTION))
//     return axios
//       .post(
//         `${config.API_URL}/laundryServiceItem/toogle-delivery/${id}`,
//         values
//       )
//       .then(data => {
//         dispatch(action(TOOGLE_DELIVERY.SUCCESS, { id }))
//         return data
//       })
//       .catch(e => dispatch(actionFailed(TOOGLE_DELIVERY, e)))
//   }
// }
